async function withRetries(asyncFunc, maxAttempts = 5) {
  let attempt = 0;
  let lastError;
  while (attempt < maxAttempts) {
    try {
      return await asyncFunc();
    } catch (err) {
      lastError = err;
      attempt++;
      if (attempt < maxAttempts) {
        await new Promise((res) => setTimeout(res, 500));
      }
    }
  }
  throw lastError;
}

export { withRetries };
